// extracted by mini-css-extract-plugin
export var media = "inner-module--media--AJnK6";
export var iframe = "inner-module--iframe--19CT5";
export var content = "inner-module--content--2arho";
export var additional = "inner-module--additional--V6k-z";
export var info = "inner-module--info--2TbmR";
export var lang = "inner-module--lang--1Eg3A";
export var lang_flag = "inner-module--lang_flag--2Nm63";
export var lang_text = "inner-module--lang_text--25rkE";
export var mainBtn = "inner-module--mainBtn--3uKC-";
export var arrow = "inner-module--arrow--3gq7u";
export var fullScreen = "inner-module--fullScreen--39tC0";
export var fullScreenBtn = "inner-module--fullScreenBtn--jL6Yt";